import React, { useState, useRef, useEffect } from "react";
import FormInputs from "../../../../components/UI/FormInputs";
import RadioButton from "../../../../components/UI/FormInputs/RadioButton";
import {
  convertUnderScoreStrings,
  isObject,
  isSet,
} from "../../../../utils/commonUtils";
import EmrVisitsService from "../../../../services/EmrVisitsService";
import Buttons from "../../../../components/UI/Buttons";
import WithRoutify from "../../../../hoc/WithRoutify";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Alert from "../../../../components/UI/ConfirmBox/Alert";
import Icons from "../../../../components/UI/Icons";
const NewAssesmentTabForm = ({
  visit_id,
  Toast,
  employee_id,
  selectedIcdCodes = [],
  formStates,
  setFormStates,
  setProgressApiTrigger,
  isFormDirty,
  setIsFormDirty,
  showUnsavedAlert,
  setShowUnsavedAlert,
  pendingCallback,
  setPendingCallback,
  setIsChartingSectionDirty,

  ...props
}) => {
  // const [formStates, setFormStates] = useState({});
  // console.log("selectedIcdCodes", selectedIcdCodes);
  useEffect(() => {
    if (!formStates?.chronicity) {
      setFormStates((prev) => ({
        ...prev,
        chronicity: "acute",
      }));
    }
  }, [formStates?.chronicity]);

  const [validation, setValidation] = useState({});
  const collapseRefs = useRef({});
  const fieldSectionRefs = useRef({});
  // Scroll to first error when validation state updates
  useEffect(() => {
    const errorKeys = Object.keys(validation);
       if (errorKeys.length > 0) {
        const firstErrorField = assessmentFields.find((field) => validation[field.name]);
        if (firstErrorField && fieldSectionRefs.current[firstErrorField.name]) {
        fieldSectionRefs.current[firstErrorField.name].scrollIntoView({
          behavior: "smooth",
          block: "center", // Centers the field in the screen
        });
      }
    }
  }, [validation]);
  // useEffect(() => {

  // }, [props.diagnoses]);
  const Diagnosis = [
    {
      title: "Musc-Back",
      data: [
        {
          type: "SelectSearchFields",
          label: "Diagnosis 1",
          placeholder: "Diagnosis 1",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_1",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 2",
          placeholder: "Diagnosis 2",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_2",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 3",
          placeholder: "Diagnosis 3",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_3",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 4",
          placeholder: "Diagnosis 4",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_4",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 5",
          placeholder: "Diagnosis 5",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_5",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 6",
          placeholder: "Diagnosis 6",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_6",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 7",
          placeholder: "Diagnosis 7",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_7",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 8",
          placeholder: "Diagnosis 8",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_8",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 9",
          placeholder: "Diagnosis 9",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_9",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 10",
          placeholder: "Diagnosis 10",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_10",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 11",
          placeholder: "Diagnosis 11",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_11",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
        {
          type: "SelectSearchFields",
          label: "Diagnosis 12",
          placeholder: "Diagnosis 12",
          className: "form-group sh_emrtableformgroup  mb-0",
          name: "diagnosis_12",
          col: "col-6",
          options: props.icd10List,
          isAsync: true,
          isCacheNeeded: false,
          loadCallBack: (val, callback) => props.fetchIcd10List(val, callback),
        },
      ],
    },
  ];
  const [diagnosisList, setDiagnosisList] = useState(Diagnosis);
  // --- ADDED: Alert handler functions ---
  const handleProceed = () => {
    if(setIsChartingSectionDirty) setIsChartingSectionDirty(false);
    if(setIsFormDirty) setIsFormDirty(false);
    if(setShowUnsavedAlert) setShowUnsavedAlert(false);
   if (pendingCallback) {
      
      setTimeout(() => {
        pendingCallback();
      }, 0); 
    }
    
    if(setPendingCallback) setPendingCallback(null);
    
  };
  
  const handleCancel = () => {
    if(setShowUnsavedAlert) setShowUnsavedAlert(false);
    if(setPendingCallback) setPendingCallback(null);
  };
  const assessmentFields = [
    // {
    //   label: "E&M Risk Level",
    //   type: "RadioGroup",
    //   name: "e_m_risk_problem",
    //   id: "e_m_risk_problem",
    //   options: [
    //     { label: "Minimal", value: "minimal" },
    //     { label: "Low", value: "low" },
    //     { label: "Moderate", value: "moderate" },
    //     { label: "High", value: "high" },
    //   ],
    // },
    {
      label: "Chronicity",
      type: "RadioGroup",
      name: "chronicity",
      id: "chronicity",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Chronic", value: "chronic" },
        { label: "Acute", value: "acute" },
        { label: "Self Limited", value: "self_limited" },
      ],
    },
    {
      label: "Current Degree Of Control",
      type: "RadioGroup",
      name: "current_degree_control",
      id: "current_degree_control",
      options: [
        { label: "N/A", value: "na" },
        { label: "Controlled", value: "controlled" },
        { label: "Uncontrolled", value: "uncontrolled" },
        { label: "Questionable", value: "questionable" },
      ],
    },
    {
      label: "Condition (Pick any that apply)",
      type: "Checkbox",
      name: "condition",
      options: [
        { label: "Minor", value: "minor" },
        { label: "Uncomplicated", value: "uncomplicated" },
        { label: "Complicated", value: "complicated" },
        { label: "Systemic", value: "systemic" },
        { label: "Mild Exacerbation", value: "mild_exacerbation" },
        { label: "Severe Exaceberation", value: "Severe Exaceberation" },
        { label: "Life Threatining", value: "Life Threatining" },
      ],
    },
    {
      label: "Existing Problem Status (Follow-Up Visits)",
      type: "Checkbox",
      name: "existing_problem",
      options: [
        { label: "Resolved", value: "resolved" },
        { label: "Stable", value: "stable" },
        { label: "Improved", value: "improved" },
        { label: "Worsening", value: "worsening" },
      ],
    },
    {
      label: "New Problem Status (New Injury / Initial Urgent Care Visits)",
      type: "Checkbox",
      name: "new_problem",
      options: [
        {
          label: "Additional Work-up Required",
          value: "additional_workup_required",
        },
        {
          label: "No Additional Work-up Required",
          value: "no_additional_workup_required",
        },
      ],
    },
  ];
  const assessmentFields1 = [
    {
      label: "Assessment",
      type: "Input",
      name: "assessment",
      id: "assessment",
      placeholder: "Assessment",
      disabled: true,
    },
    {
      label: "ICD-10 DX",
      type: "Input",
      name: "icd10",
      id: "icd10",
      placeholder: "Search",
      disabled: true,
    },
    {
      label: "Cause of Injury",
      type: "TextArea",
      name: "cause_of_injury",
      id: "cause_of_injury",
      rows: 4,
      placeholder: "Enter cause of injury",
    },
    {
      label: "Activity at Time of Injury",
      type: "TextArea",
      name: "activity_at_time_of_injury",
      id: "activity_at_time_of_injury",
      rows: 4,
      placeholder: "Enter activity at time of injury",
    },
    {
      label: "Physical Location Where Injury Occurred",
      type: "TextArea",
      name: "phys_injury_location",
      id: "phys_injury_location",
      placeholder: "Enter physical location",
    },
  ];
  const sectionFields = [
    {
      label: "Security Required",
      type: "RadioGroup",
      name: "security_required",
      id: "security_required",
      options: [
        { label: "No Special Security", value: "no_special_security" },
        { label: "EAP Access", value: "eap_access" },
        { label: "Personal Health and Wellness", value: "health_wealth" },
      ],
    },
    {
      label: "E&M Risk Level",
      type: "RadioGroup",
      name: "e_m_risk_problem",
      id: "e_m_risk_problem",
      options: [
        { label: "Minimal", value: "minimal" },
        { label: "Low", value: "low" },
        { label: "Moderate", value: "moderate" },
        { label: "High", value: "high" },
      ],
    },
    // {
    //   label: "Problem Count",
    //   type: "Input",
    //   name: "problemCount",
    //   id: "problemCount",
    //   placeholder: "Count",
    // },
    {
      label: "Chronicity",
      type: "RadioGroup",
      name: "chronicity",
      id: "chronicity",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Chronic", value: "chronic" },
        { label: "Acute", value: "acute" },
        { label: "Self Limited", value: "self_limited" },
      ],
    },
    {
      label: "Current Degree Of Control",
      type: "RadioGroup",
      name: "current_degree_control",
      id: "current_degree_control",
      options: [
        { label: "N/A", value: "na" },
        { label: "Controlled", value: "controlled" },
        { label: "Uncontrolled", value: "uncontrolled" },
        { label: "Questionable", value: "questionable" },
      ],
    },
  ];

  const locationSpecificityGroups = [
    {
      label: "Laterality",
      name: "location_left_right",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Left", value: "Left" },
        { label: "Right", value: "Right" },
        { label: "Bilateral", value: "Bilateral" },
      ],
    },
    {
      label: "Foot Surface",
      name: "location_plantar_dorsal",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Dorsal", value: "Dorsal" },
        { label: "Plantar", value: "Plantar" },
      ],
    },
    {
      label: "Side",
      name: "location_medial_lateral",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Medial", value: "Medial" },
        { label: "Lateral", value: "Lateral" },
      ],
    },
    {
      label: "Direction",
      name: "location_anterior_posterior",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Anterior", value: "Anterior" },
        { label: "Posterior", value: "Posterior" },
      ],
    },
    {
      label: "Position",
      name: "location_proximal_distal",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Proximal", value: "Proximal" },
        { label: "Distal", value: "Distal" },
      ],
    },
  ];

  const additionalAssessmentFields = [
    {
      label: "Intractable",
      type: "RadioGroup",
      name: "intractable",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],
    },
    {
      label: "Condition (Pick any that apply)",
      type: "Checkbox",
      name: "condition",
      options: [
        { label: "Minor", value: "minor" },
        { label: "Uncomplicated", value: "uncomplicated" },
        { label: "Complicated", value: "complicated" },
        { label: "Systemic", value: "systemic" },
        { label: "Mild Exacerbation", value: "mild_exacerbation" },
        { label: "Severe Exaceberation", value: "Severe Exaceberation" },
        { label: "Life Threatining", value: "Life Threatining" },
      ],
    },
    {
      label: "Existing Problem Status",
      type: "Checkbox",
      name: "existing_problem",
      options: [
        { label: "Resolved", value: "resolved" },
        { label: "Stable", value: "stable" },
        { label: "Improved", value: "improved" },
        { label: "Worsening", value: "worsening" },
      ],
    },
    {
      label: "New Problem Status",
      type: "Checkbox",
      name: "new_problem",
      options: [
        {
          label: "Additional Work-up Required",
          value: "additional_workup_required",
        },
        {
          label: "No Additional Work-up Required",
          value: "no_additional_workup_required",
        },
      ],
    },
    {
      label: "Assesment Timing",
      type: "RadioGroup",
      name: "assessment_time",
      options: [
        { label: "N/A", value: "N/A" },
        { label: "Intial", value: "intial" },
        { label: "Subsequent", value: "subsequent" },
        { label: "Sequela", value: "sequela" },
      ],
    },
    {
      label: "Additional Notes",
      type: "TextArea",
      name: "additional_note",
      placeholder: "Enter notes here",
    },
  ];

  const updateFormState = (type, field, value, checked) => {
    if (setIsFormDirty) setIsFormDirty(true);
    setValidation({ ...validation, [field]: "" });
    console.log(type, field, value, checked);
    if (type === "Checkbox") {
      const prevArray = formStates[field] || [];
      let newArray = [];
      if (checked) {
        // add to array
        newArray = [...prevArray, value];
      } else {
        // remove from array
        newArray = prevArray.filter((item) => item !== value);
      }
      value = newArray;
    }

    setFormStates((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleDone = async (icd_id) => {
    try {
      let updateValidation = {};
      const rawForm = formStates || {};

      const payload = {
        ...rawForm,
        type:
          props.VISITCATEGORY === "Work Comp - New Injury"
            ? "incident"
            : "no incident",
        screen_type: "ASSESSMENT",
        employee_id: employee_id,
        condition: (rawForm.condition || []).join(","),
        existing_problem: (rawForm.existing_problem || []).join(","),
        new_problem: (rawForm.new_problem || []).join(","),

        cause_of_injury: rawForm.cause_of_injury || "",
        activity_at_time_of_injury: rawForm.activity_at_time_of_injury || "",
        phys_injury_location: rawForm.phys_injury_location || "",
        security_required: rawForm.security_required || "",
        e_m_risk_problem: rawForm.e_m_risk_problem || "",
        chronicity: rawForm.chronicity || "",
        current_degree_control: rawForm.current_degree_control || "",
        location_anterior_posterior: rawForm.location_anterior_posterior || "",
        location_left_right: rawForm.location_left_right || "",
        location_medial_lateral: rawForm.location_medial_lateral || "",
        location_plantar_dorsal: rawForm.location_plantar_dorsal || "",
        location_proximal_distal: rawForm.location_proximal_distal || "",
        intractable: rawForm.intractable || "",
        assessment_time: rawForm.assessment_time || "",
        additional_note: rawForm.additional_note || "",
        diagnosis_1: rawForm["diagnosis_1"] || "",
        diagnosis_1_label: rawForm["diagnosis_1_label"] || "",

        diagnosis_2: rawForm["diagnosis_2"] || "",
        diagnosis_2_label: rawForm["diagnosis_2_label"] || "",

        diagnosis_3: rawForm["diagnosis_3"] || "",
        diagnosis_3_label: rawForm["diagnosis_3_label"] || "",

        diagnosis_4: rawForm["diagnosis_4"] || "",
        diagnosis_4_label: rawForm["diagnosis_4_label"] || "",

        diagnosis_5: rawForm["diagnosis_5"] || "",
        diagnosis_5_label: rawForm["diagnosis_5_label"] || "",

        diagnosis_6: rawForm["diagnosis_6"] || "",
        diagnosis_6_label: rawForm["diagnosis_6_label"] || "",

        diagnosis_7: rawForm["diagnosis_7"] || "",
        diagnosis_7_label: rawForm["diagnosis_7_label"] || "",

        diagnosis_8: rawForm["diagnosis_8"] || "",
        diagnosis_8_label: rawForm["diagnosis_8_label"] || "",

        diagnosis_9: rawForm["diagnosis_9"] || "",
        diagnosis_9_label: rawForm["diagnosis_9_label"] || "",

        diagnosis_10: rawForm["diagnosis_10"] || "",
        diagnosis_10_label: rawForm["diagnosis_10_label"] || "",

        diagnosis_11: rawForm["diagnosis_11"] || "",
        diagnosis_11_label: rawForm["diagnosis_11_label"] || "",

        diagnosis_12: rawForm["diagnosis_12"] || "",
        diagnosis_12_label: rawForm["diagnosis_12_label"] || "",
      };

      const results = await EmrVisitsService.saveAssessment(
        null,
        visit_id,
        icd_id,
        payload
      );
      setProgressApiTrigger((prev) => !prev);
      if (results?.status === 200 || results?.status === "SUCCESS") {
        props.handleComplete();
        setFormStates({});
        props.handleToggleIcd();
        Toast.success(`Data saved successfully.`);
        if(setIsFormDirty) setIsFormDirty(false);
        if(setIsChartingSectionDirty) setIsChartingSectionDirty(false);
        
        // Trigger AI suggestions refresh after saving (including when diagnoses are removed)
        // Use setTimeout to ensure backend save completes first
        if (props.onDiagnosisRemoved) {
          setTimeout(() => {
            props.onDiagnosisRemoved();
          }, 500);
        }
        
        return true;
      } else if (results.status === "ERROR") {
        const resultData = results.data;
        if (isObject(results.data)) {
          for (let key in results.data) {
            const errorMessage = results.data[key].join(", ");
            // Toast.error(errorMessage);
            updateValidation = {
              ...updateValidation,
              [key]: errorMessage,
            };
          }
        }
        if (Object.keys(updateValidation).length > 0) {
          setValidation(updateValidation);
        }
        return false;
      }

      return false;
    } catch (error) {
      console.error("Save failed:", error);
      Toast.error("Something went wrong while saving.");
      return false;
    }
  };
  const handlerDiagnosis = (name, val, label) => {
    if (setIsFormDirty) setIsFormDirty(true);
    setFormStates((prev) => {
      const updated = {
        ...prev,
        [name]: val,
        [`${name}_label`]: label,
      };

      // Also update diagnoses array if needed
      if (props.diagnoses && props.setDiagnoses) {
        const newDiagnoses = diagnosisList[0].data.map(
          (item) => updated[item.name] || ""
        );
        props.setDiagnoses(newDiagnoses);
      }

      return updated;
    });
  };
  // remove diagnosis by index: clear slot in props.diagnoses and clear formStates keys
  const removeDiagnosis = (index) => {
    if (setIsFormDirty) setIsFormDirty(true);
    try {
      // clear diagnoses array slot if provided
      if (
        props.diagnoses &&
        Array.isArray(props.diagnoses) &&
        props.setDiagnoses
      ) {
        const updated = [...props.diagnoses];
        if (index >= 0 && index < updated.length) {
          updated[index] = "";
          props.setDiagnoses(updated);
        }
      }

      // clear formStates keys for this diagnosis slot
      setFormStates((prev) => ({
        ...prev,
        [`diagnosis_${index + 1}`]: "",
        [`diagnosis_${index + 1}_label`]: "",
      }));

      // Trigger AI suggestions refresh if callback is provided
      if (props.onDiagnosisRemoved) {
        props.onDiagnosisRemoved();
      }
    } catch (err) {
      console.error("removeDiagnosis error", err);
    }
  };
  const handleDragEnd = (result) => {
    
    if (!result.destination) return;
    if (setIsFormDirty) setIsFormDirty(true);
    const sectionIndex = 0;
    const newData = Array.from(diagnosisList[sectionIndex].data);

    // 1. Move the *field configuration* in the data array
    const [movedItem] = newData.splice(result.source.index, 1);
    newData.splice(result.destination.index, 0, movedItem);

    // 2. Update labels and names for the field configuration array
    const updatedData = newData.map((item, i) => ({
      ...item,
      label: `Diagnosis ${i + 1}`,
      name: `diagnosis_${i + 1}`,
      placeholder: `Diagnosis ${i + 1}`,
    }));

    // 3. Update state for UI
    const updatedList = [...diagnosisList];
    updatedList[sectionIndex].data = updatedData;
    setDiagnosisList(updatedList);

    // 4. Swap the values in formStates (The Correction)
    setFormStates((prev) => {
      const newFormStates = { ...prev };

      // Find the names of the diagnosis fields at the source and destination indices
      // NOTE: The 'diagnosis_1', 'diagnosis_2', etc. names in `updatedData` are
      // the *new* names, but we need the *old* names to get the values from `prev`.
      // The names in `prev` before this operation correspond to the field names *before* the drag.

      // Since we don't have the "old" names easily, we can use the `props.diagnoses` array
      // if it's up to date, or just focus on swapping the values themselves.

      // Let's create an array of the current values/labels in their *drag-reordered* sequence
      // based on the *original* names of the items.

      // The item at `result.source.index` has moved to `result.destination.index`.
      // We need to know what value/label was associated with the item at `result.source.index`
      // and what value/label was associated with the item at `result.destination.index` *before* the move.

      // Since `diagnosisList` state already has the previous names, we can use that:
      const oldDiagnosisData = diagnosisList[sectionIndex].data;

      // Get the *value/label* that was at the source position
      const sourceField = oldDiagnosisData[result.source.index];
      const sourceValue = prev[sourceField.name] || "";
      const sourceLabel = prev[`${sourceField.name}_label`] || "";

      // Get the *value/label* that was at the destination position
      const destField = oldDiagnosisData[result.destination.index];
      const destValue = prev[destField.name] || "";
      const destLabel = prev[`${destField.name}_label`] || "";

      // The key to fixing this is realizing that the `updatedData` has the new names.
      // The field that is now `diagnosis_1` should have the value that was at the
      // *original* position of the item that moved to `diagnosis_1`'s spot.

      const reorderedValues = Array.from(oldDiagnosisData);
      const [movedValue] = reorderedValues.splice(result.source.index, 1);
      reorderedValues.splice(result.destination.index, 0, movedValue);

      // Now reorderedValues is an array of objects *with old names* in the new order.
      // We can map the new names from `updatedData` to the values from `reorderedValues`.
      updatedData.forEach((item, i) => {
        const oldName = reorderedValues[i].name;
        newFormStates[item.name] = prev[oldName] || ""; // Assign old value to new name
        newFormStates[`${item.name}_label`] = prev[`${oldName}_label`] || "";
      });

      // Clean up the old (now unused) names, although usually not strictly necessary if overwriting
      // for (let i = 1; i <= 12; i++) {
      //   const oldName = `diagnosis_${i}`;
      //   if (!updatedData.some(d => d.name === oldName)) {
      //     delete newFormStates[oldName];
      //     delete newFormStates[`${oldName}_label`];
      //   }
      // }

      // Update props.diagnoses if needed
      if (props.setDiagnoses) {
        const newDiagnoses = updatedData.map(
          (item) => newFormStates[item.name] || ""
        );
        props.setDiagnoses(newDiagnoses);
      }

      return newFormStates;
    });
  };

  const handleSubmit = async () => {
    // Only call the assessment save API, skip incident API call
    const saveSuccess = await handleDone(null);
    return saveSuccess;
  };
  const ClearHandler = async () => {
    try {
      props.Loader(true);
      const cleardata = {
        ...formStates,
        type:
          props.VISITCATEGORY === "Work Comp - New Injury"
            ? "incident"
            : "no incident",
        clearhandler: true,
        screen_type: "ASSESSMENT",
        employee_id: employee_id,
        cause_of_injury: "",
        activity_at_time_of_injury: "",
        phys_injury_location: "",
        security_required: "",
        e_m_risk_problem: "",
        chronicity: "",
        current_degree_control: "",
        condition: "",
        existing_problem: "",
        new_problem: "",
        location_left_right: "",
        location_plantar_dorsal: "",
        location_medial_lateral: "",
        location_anterior_posterior: "",
        location_proximal_distal: "",
        intractable: "",
        assessment_time: "",
        additional_note: "",
        diagnosis_1: "",
        diagnosis_1_label: "",

        diagnosis_2: "",
        diagnosis_2_label: "",

        diagnosis_3: "",
        diagnosis_3_label: "",

        diagnosis_4: "",
        diagnosis_4_label: "",

        diagnosis_5: "",
        diagnosis_5_label: "",

        diagnosis_6: "",
        diagnosis_6_label: "",

        diagnosis_7: "",
        diagnosis_7_label: "",

        diagnosis_8: "",
        diagnosis_8_label: "",

        diagnosis_9: "",
        diagnosis_9_label: "",

        diagnosis_10: "",
        diagnosis_10_label: "",

        diagnosis_11: "",
        diagnosis_11_label: "",

        diagnosis_12: "",
        diagnosis_12_label: "",
      };

      const results = await EmrVisitsService.saveAssessment(
        null,
        visit_id,
        null,
        cleardata
      );
      if (results?.status === 200 || results?.status === "SUCCESS") {
        setFormStates({});
        props.handleToggleIcd();
        props.setDiagnoses(["", "", "", "", "", "", "", "", "", "", "", ""]);
        
        // Refresh progress note
        setProgressApiTrigger((prev) => !prev);
        
        // Remove tick from Assessment tab when data is cleared
        if (props.handleIncomplete) {
          props.handleIncomplete();
        }
        
        Toast.success(`Data cleared successfully.`);
        if(setIsFormDirty) setIsFormDirty(false);
        if(setIsChartingSectionDirty) setIsChartingSectionDirty(false);
        
        // Trigger AI suggestions refresh after clearing all diagnoses
        // Use setTimeout to ensure backend save completes first
        if (props.onDiagnosisRemoved) {
          setTimeout(() => {
            props.onDiagnosisRemoved();
          }, 500);
        }
      }
    } catch (err) {
      console.error("Error clearing data", err);
      Toast.error("Something went wrong while clearing.");
    } finally {
      props.Loader(false);
    }
  };
  const requiredFields = new Set([
    "current_degree_control",
    "condition",
    "existing_problem",
    "new_problem",
  ]);
  return (
    <div className="col-9">
      <div className="card sh_basecard">
        <div class="card-header p-2 sh_basecardHeader">
          <div class="d-flex w-100 justify-content-between align-items-center">
            {" "}
            Assessment Form
            <div class="d-flex">
              {formStates["assessment_id"] && (
                <Buttons
                  clickHandler={() => ClearHandler()}
                  className="btn  sh_btnlight p3-light mr-2"
                  acl={"any"}
                  isDelete={true}
                  label={"Clear All"}
                />
              )}
              <Buttons
                className="btn btn-primary sh_btnprimary"
                title={"Accept"}
                acl={"any"}
                clickHandler={() => {
               handleSubmit();
                }}
              >
                Accept / Replace
              </Buttons>
            </div>
          </div>
        </div>
        <div className="card-body py-2 px-0">
          {diagnosisList.map((section, index) => {
            return (
              <div className="row">
                <div className="card w-100 mb-0 shadow-none border-0">
                  {/* <div className="card-header sh_subaccordionheader">
                    {section.title}
                    {isSet(validation[section.title], "") !== "" ? (
                      <span className="text-danger m-1">
                        {isSet(validation[section.title], "")}
                      </span>
                    ) : (
                      ""
                    )}
                  </div> */}
                  <div className="card-body  py-2 px-0">
                    <div className="row">
                      {/* {section.data.map((field, idx) => {                        
                          return (<>
                        <div className="col-6">
                          <div className="form-group row mb-1">
                            <label className="col-form-label col-5">{field.label}</label>
                          <div className="col-7"><FormInputs
                              key={idx}
                              {...field}
                              value={props.diagnoses[idx]|| ""}
                              displayValue={formStates[`diagnosis_${idx+1}_label`] || ''}
                              changeHandler={(val,e,label) => { handlerDiagnosis(field.name,idx,val,label)}} />
                            </div>
                            </div> 
                        </div>                          
                          </>
                          )
                        })} */}

                      <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="diagnosisList">
                          {(provided) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              className="row"
                            >
                              {section.data.map((field, idx) => (
                                <Draggable
                                  key={field.name}
                                  draggableId={field.name}
                                  index={idx}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className={`col-6 border-bottom mb-2 ${
                                        snapshot.isDragging ? "bg-light" : ""
                                      }`}
                                      style={{
                                        userSelect: "none",
                                        ...provided.draggableProps.style,
                                        backgroundColor:snapshot.isDragging ? "#ffffff":"#F7F9FF"
                                      }}
                                    >
                                      <div className="form-group row mb-1  p-1">
                                        <label className="col-form-label col-5">
                                          {field.label}{" "}
                                          <span style={{ cursor: "grab" }}>
                                            ⠿
                                          </span>
                                        </label>
                                        <div className="col-7">
                                          <div className="d-flex align-items-center">
                                            <div style={{ flex: 1 ,minWidth:0}}>
                                              <FormInputs
                                                key={field.name} // use field name as key
                                                {...field}
                                                value={
                                                  formStates[field.name] || ""
                                                } // use formStates keyed by field.name
                                                displayValue={
                                                  formStates[
                                                    `${field.name}_label`
                                                  ] || ""
                                                }
                                                changeHandler={(
                                                  val,
                                                  e,
                                                  label
                                                ) => {
                                                  handlerDiagnosis(
                                                    field.name,
                                                    val,
                                                    label
                                                  );
                                                }}
                                              />
                                            </div>
                                            <div style={{ marginLeft: 8 }}>
                                              <span
                                                title="Remove diagnosis"
                                                className="cursor-pointer"
                                                onClick={() =>
                                                  removeDiagnosis(idx)
                                                }
                                                aria-label={`remove-diagnosis-${idx}`}
                                              >
                                                <Icons
                                                  type={"Remove"}
                                                  fontSize={"23px"}
                                                />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {assessmentFields.map((item, index) => {
            const isRequired = requiredFields.has(item.name);
            return (
              <div className="row" key={index} ref={(el) => (fieldSectionRefs.current[item.name] = el)}>
                <div className="card w-100 mb-0 shadow-none p-1 border-0">
                  <div className="card-header sh_subaccordionheader font-weight-bold text-dark">
                    {item.label}
                    {isRequired && <span className="text-danger ml-1">*</span>}
                    {isSet(validation[item.name], "") !== "" ? (
                      <span className="text-danger m-1 fw-light">
                        {isSet(validation[item.name], "")}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="card-body  py-2 px-0">
                    <div className="row">
                      {item.type === "RadioGroup" ? (
                        <div className="form-group sh_emrtableformgroup  col-12 pl-3 mb-0 d-flex align-items-center">
                          <FormInputs
                            key={index}
                            {...item}
                            value={
                              formStates[item.name] || ""
                              // formStates["diagnosis_"+(idx+1)] || ""
                            }
                            changeHandler={(val) => {
                              updateFormState(item.type, item.name, val, "");
                            }}
                          />
                        </div>
                      ) : (
                        item.options.map((field, idx) => {
                          const value = formStates[item.name]
                            ? item.type === "Checkbox"
                              ? Array.isArray(formStates[item.name]) &&
                                formStates[item.name].includes(field.value)
                              : formStates[item.name] === field.value
                            : "";
                          return (
                            <div className="form-group sh_emrtableformgroup pl-3 col-4 mb-0 d-flex align-items-center">
                              <FormInputs
                                key={`${idx}`}
                                id={item.name + "_" + idx}
                                {...item}
                                value={
                                  value
                                  // formStates["diagnosis_"+(idx+1)] || ""
                                }
                                changeHandler={(val, e) => {
                                  updateFormState(
                                    item.type,
                                    item.name,
                                    field.value,
                                    e.e.target.checked
                                  );
                                }}
                              />

                              <label
                                className="formlabel mb-0"
                                htmlFor={item.name + "_" + idx}
                              >
                                {" "}
                                {field.label}{" "}
                              </label>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "10px", // optional
        }}
      >
        <Buttons
          className="btn btn-primary sh_btnprimary"
          title={"Accept"}
          acl={"any"}
          clickHandler={() => {
            handleSubmit();
          }}
        >
          Accept / Replace
        </Buttons>
      </div>
      {showUnsavedAlert && (
        <Alert
          contentTitle="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
          content="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
          yesButtonName="Discard"
          noButtonName="Cancel"
          type="warning"
          onDelete={handleProceed}   // Discard
          onClose={handleCancel}     // Cancel
          confirmButtonClassName="btn btn-danger"
          cancelButtonClassName="btn btn-secondary"
          saveAndClose={true} 
          onSaveAndClose={async () => { 
            // Call the main save function
            const success = await handleSubmit(); // Use handleSubmit
            if (success) {
              handleProceed(); // Navigate away if save was successful
            }
            else{
              handleCancel();
            }
          }}
        />
      )}
    </div>
  );
};

export default WithRoutify(NewAssesmentTabForm);